// 1. Fetch available editions
export function getEpaperEditions() {
  return fetch("https://api-epaper-prod.deccanherald.com/epaper/editions?publisher=DH", {
    method: "GET",
    headers: { accept: "application/json" }
  }).then((res) => res.json());
}
// 2. Fetch user's current preference
export function getEpaperPreferences() {
  const access_token = typeof window !== "undefined" ? localStorage.getItem("access_token") : null;
  if (!access_token) return Promise.resolve(null);

  return fetch("https://api-epaper-prod.deccanherald.com/users/preferences?publisher=DH", {
    method: "GET",
    headers: {
      accept: "application/json",
      Authorization: `Bearer ${access_token}`
    }
  }).then((res) => (res.ok ? res.json() : null)).catch(() => null);
}
// 3. Update preference
export function updateEpaperPreferences(editionId) {
  const access_token = typeof window !== "undefined" ? localStorage.getItem("access_token") : null;
  if (!access_token) return Promise.reject("No token");
  const payload = {
    dh_preferred_edition_id: editionId,
    welcome_popup_enabled: true
  };
  return fetch("https://api-epaper-prod.deccanherald.com/users/preferences", {
    method: "PATCH",
    headers: {
      accept: "*/*",
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`
    },
    body: JSON.stringify(payload)
  }).then((res) => {
    if (res.ok) return res.json();
    throw new Error("Failed to update preferences");
  });
}
